const { REACT_APP_BASE_URL: BASE_API_URL } = process.env;

// url for get all notes by leadId
export const GET_ALL_NOTES_BY_LEAD = `${BASE_API_URL}/tasks/notes/notes_by_lead/`;
